// extracted by mini-css-extract-plugin
export default {"additional-info":"styles_additional-info__j0fc-","additional-info-edit":"styles_additional-info-edit__tcO4I"};